<template>
    <el-dialog class="common-dialog noHeader register-info-dialog industry" title="贵公司所属行业是?" :visible="isShowModal" :show-close="false">
        <div class="content">
            <div class="industry-item"
                 v-for="item in industries"
                 :key="item._id"
                 :title="item.name"
                 :class="{'active': item._id === selectedItem}" @click="select(item._id)">
                <img :src="getImage(item)" :alt="item.name">
                <span class="textEllipsis">{{item.shortTitle}}</span>
            </div>
        </div>
        <el-button type="primary" size="full" @click="save()">下一步</el-button>
    </el-dialog>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
    data() {
        return {
            selectedItem: ''
        }
    },
    computed: {
        ...mapState(['loginStep', 'user']),
        ...mapState('company', ['industries']),
        isShowModal() {
            return this.loginStep === 'industry';
        }
    },
    methods: {
        ...mapMutations(['setLoginStep']),
        ...mapMutations('company', ['setCompanyInfo']),
        getImage(item) {
            let isActive = item._id === this.selectedItem ? '-active' : '';
            return '../../content/images/industry/'+ item.sort + isActive +'.png';
        },
        select(id) {
            this.selectedItem = id;
        },
        save() {
            if (!this.selectedItem) {
                this.$message.error('请选择所属行业');
                return;
            }
            this.setCompanyInfo({industry: this.selectedItem});
            this.setLoginStep('password');
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    height: 20.3rem;
    padding: 1rem 1rem 0;
    font-size: .7rem;
    text-align: center;
    border: 1px solid #e6e6e6;

    .industry-item {
        width: 20%;
        height: 25%;
        cursor: pointer;
        img {
            height: 45%;
        }
        &.active {
            color: #2472e8;
        }
    }
}
</style>
<style>
    .register-info-dialog.industry .el-dialog__header {
        padding-bottom: 1rem;
    }
</style>


// WEBPACK FOOTER //
// app/view/login/LoginIndustry.vue